import React from 'react'
import ResourceTable from '../components/resourceTable'
import {clsx, styled} from 'external/material'

import { TeacherContext } from 'teacher/context'
import {useContext, useMemo} from 'external/react'
import ScheduleSpecialistMeeting from './ScheduleSpecialistMeeting'

const manuals = {
  'dgenius': ['eduboard', 'viewer', 'viewer-student'],
  'de': ['eduboard', 'viewer', 'viewer-student'],
  'edusystem': ['eduboard', 'viewer', 'viewer-student'],
}

const tools = ['viewer', 'multi-touch']

const StyledHelp = styled('div')(helpStyles)

export default function Help () {
    const context = useContext(TeacherContext)
    const {profile, displayingScheduleMeeting} = context
    const {project} = profile.institution
    const isDreyfous = useMemo(() => profile.domain === 'dreyfous', [profile.domain])
    const manual = manuals[project] || manuals['edusystem']
    return (
    <StyledHelp className={clsx({displayingMeeting: displayingScheduleMeeting})}>
      <div className="resource-tables">
        <ResourceTable kind="manuals" resources={manual} />
        <ResourceTable kind="tools" resources={tools} />
      </div>
      {isDreyfous && <ScheduleSpecialistMeeting />}
    </StyledHelp>)
}

function helpStyles () {
  return {
    display: 'flex',
    padding: 20,
    flexDirection: 'column',
    marginTop: 10,
    flexGrow: 1,
    '&.displayingMeeting': {
      '& .resource-tables': {
        display: 'none',
      }
    }
  }
}
